import { lookupPackageKnowledge, PackageKnowledge } from "./packageRegistry.js";

/**
 * Reviews package details and resolves matching native requirements configs.
 */
export function analyzeNativeRequirements(packageName: string): PackageKnowledge | null {
  return lookupPackageKnowledge(packageName);
}
